import { createContext } from 'react';

interface InfoContextProps {
  setTitle: (title: string) => void;
  title: string;
}

export const InfoContext = createContext({} as InfoContextProps);
